module.exports = __webpack_public_path__ + "img/IMG_0530.1f66f5f7.jpg";